<template>
  <div class="eng">
    <Form :label-width="70">
      <Row :gutter="32">
        <Col :md="7">
          <FormItem label="工程名称">
            <Input v-model="searchQuery.Gcmc" placeholder="请输入工程名称" />
          </FormItem>
        </Col>
        <Col :md="7">
          <FormItem label="工程地址">
            <Input v-model="searchQuery.Jzdz" placeholder="请输入工程地址" />
          </FormItem>
        </Col>
        <Col :md="7">
          <FormItem label="建设单位">
            <Input v-model="searchQuery.Jsdw" placeholder="请输入建设单位" />
          </FormItem>
        </Col>
        <Col :md="3" class-name="inquireBtn">
          <Button
            class="submitBtn"
            type="primary"
            @click="handleSubmit"
          >查询</Button>
        </Col>
      </Row>
    </Form>
    <Table
      ref="table"
      border
      stripe
      :columns="columns"
      :data="data"
      :loading="loading"
      highlight-row
      @on-row-click="clickRow"
    />
    <Page
      v-if="total > pageSize"
      :total="total"
      show-sizer
      show-elevator
      :page-size="pageSize"
      :current="current"
      @on-change="handleChange"
      @on-page-size-change="handlePageSizeChange"
      class-name="page"
    />
  </div>
</template>

<script>
import { localStoragePackage, getQueryString } from '@libs/util'
import { GetEngineers } from '@api'
const ticket = getQueryString('ticket') || localStoragePackage('get', 'ticket')
export default {
  name: 'search-engTable',
  data () {
    return {
      searchQuery: {
        ticket,
        Jsdw: '',
        Jzdz: '',
        Gcmc: ''
      },
      data: [],
      columns: [],
      loading: false,
      total: 0,
      pageSize: 10,
      current: 1
    }
  },
  mounted () {
    this.buildColumns()
  },
  methods: {
    buildColumns () {
      const columns = [
        {
          title: '序号',
          type: 'index',
          width: 70,
          align: 'center'
        }, {
          title: '工程名称',
          render: (h, params) => {
            const { ENG_NAME } = params.row
            return (
              <span
                class="nameLink"
              >{ ENG_NAME }</span>
            )
          }
        }, {
          title: '工程地址',
          key: 'ENG_LOCATION'
        }, {
          title: '建设单位',
          key: 'DEVELOPMENTS_ORG_NAME'
        }, {
          title: '施工单位',
          key: 'CONSTRUCT_ORG_NAME'
        }
      ]
      if (window.config.GISUrl) {
        columns.push({
          title: '操作',
          width: 90,
          align: 'center',
          render: (h, params) => {
            const { LNG } = params.row
            return (
              <Button
                type="info"
                size="small"
                disabled={ !LNG }
                onClick={ () => this.openGIS(params.row) }
              >地图</Button>
            )
          }
        })
      }
      this.$set(this, 'columns', columns)
    },
    async getPage () {
      this.$emit('on-init-table')
      this.loading = true
      try { 
        const query = Object.assign({
          PageIndex: this.current,
          PageSize: this.pageSize
        }, this.searchQuery, )
        const { data: { list, total } } = await GetEngineers(query)
        this.data = list || []
        this.total = total
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleSubmit () {
      if (Object.values(this.searchQuery).every(e => e === '')) {
        this.$Message.warning('必须录入一个查询条件')
        return
      }
      this.current = 1
      this.getPage()
    },
    handleChange (index) {
      this.current = index
      this.getPage()
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.getPage()
    },
    openGIS ({ SID }) {
      const { GISUrl } = window.config
      window.open(`${ GISUrl }?id=${ SID }`, '_blank')
    },
    clickRow (row, index) {
      this.$emit('on-click-row', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  margin-top: 16px;
  text-align: right;
}
.ivu-form-item,
.submitBtn {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>
